import React from "react";
import styled from "styled-components/macro";
import { sectionList } from "./printer";
import { PrinterJobs } from "./printer_jobs";
import { PrinterListPage } from "./printer_list_page";
import { UploadFileFullScreen } from "../UploadFilesDb/upload_file_full_screen";
import { theme } from "./theme";

const RightPanel = ({
  printers,
  section,
  jobs,
  isDev = false,
  loading = false,
  printerToOpen = null,
  onOpenPrinter,
  onPrinterToOpenConsumed,
}) => {
  const _renderBody = () => {
    switch (section) {
      case sectionList.PRINT_JOBS:
        return (
          <PrinterJobs
            printers={printers}
            jobs={jobs}
            isDev={isDev}
            loading={loading}
            onOpenPrinter={onOpenPrinter}
          />
        );
      case sectionList.PRINTERS:
        return (
          <PrinterListPage
            printers={printers}
            jobs={jobs}
            isDev={isDev}
            printerToOpen={printerToOpen}
            onPrinterToOpenConsumed={onPrinterToOpenConsumed}
          />
        );
      case sectionList.PRINT_FILE:
        return <UploadFileFullScreen printers={printers} isDev={isDev} />;
      default:
        return null;
    }
  };

  return <Wrapper>{_renderBody()}</Wrapper>;
};

const Wrapper = styled.div`
  flex: 1;
  min-width: 0;
  color: ${theme.textMuted};
  font-family: ${theme.fontFamily};
`;

export { RightPanel };
